const SubscriptionTypes = {
    Turn: 'Turn',
    Priority: 'Priority',
    Normal: 'Normal',
}

module.exports = {
    SubscriptionTypes,
}
